export default __webpack_public_path__ + "static/PEPEGOLD-82f274146269ce801138406d25a24f40.png";